import React from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { FilePreview } from 'components/common/file-preview';
import type { IDocumentPreviewButtonProps } from 'components/documents/document-item/components/document-preview-button/types';

export const DocumentPreviewButton: React.FC<IDocumentPreviewButtonProps> = (props) => {
  const { documentId, name, mimeType, getLinkForPreview } = props;

  return (
    <FilePreview
      fileName={name}
      mimeType={mimeType}
      getFileLink={() => getLinkForPreview({ documentId })}
      renderTrigger={({ onClick }) => <EyeOutlined className='hover' style={{ fontSize: 20 }} onClick={onClick} />}
    />
  );
};
